import {Component, ViewChild} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {WorkflowService} from "../workflow.service";
import {WorkflowStep} from "../workflow-step";
import {DeploymentService} from "../../deployment/deployment.service";
import {WorkflowTargetInfoModel} from "../models/workflow-target-info.model";
import {SuccessComponent} from "../../errors/success.component";
import {SelectPartnerDialogComponent} from "./dialog-select-partner.component";
import {DialogService} from "../../bootstrap-modal/dialog.service";
import {handleErrors} from "../../misc/handle-errors.decorator";
import {DeploymentWorkflowService} from "./deployment-workflow.service";

@Component({
  templateUrl: "./export-partner-installation.template.pug",
  providers: [DeploymentService, DialogService, DeploymentWorkflowService],
})

export class ExportPartnerInstallationComponent extends WorkflowStep {
  private isReady: boolean = false;
  isFileDownloading = false;
  projectId: string = "";
  deploymentId: string = "";
  disableStep: boolean = false;
  error: Error;
  partnerApiSuccess: string = "";
  allowSendingToPartner: any = {valid: false};

  @ViewChild(SuccessComponent) success: SuccessComponent;

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public workflowService: WorkflowService,
    public deploymentService: DeploymentService,
    public dialogService: DialogService,
    public deploymentWorkflowService: DeploymentWorkflowService,
  ) {
    super(true);
  }

  public async ready(workflowTargetInfo: WorkflowTargetInfoModel) {
    this.isReady = true;
    this.deploymentId = workflowTargetInfo.targetId;
    this.projectId = workflowTargetInfo.projectId;
    this.loading = false;
    this.allowSendingToPartner = await this.deploymentService.validateProjectAllowedInstallPartner(this.projectId);
  }

  @handleErrors()
  public async sendDeployToPartner() {
    const dialogResult = await SelectPartnerDialogComponent.showSelectPartnerDialogModal(
      this.dialogService,
      {
        filters: {webhooks: ["installation-partner-deployment-changed"]},
      },
    ).toPromise();

    if (!dialogResult.success) return;

    const sendResult = await this.deploymentService.sendDeploymentToInstallPartner(
      this.deploymentId,
      this.projectId,
      dialogResult.partnerSelected,
    );

    if (sendResult.success) {
      this.partnerApiSuccess = "The Data was Sent to the Partner";
    }
  }

  public async downloadPartnerInstallFile() {  
    this.isFileDownloading = true;
    let partnerFileLink = await this.deploymentWorkflowService.exportPartnerInstallationFile(
      this.deploymentId,
      this.projectId,
    ).toPromise().catch(err => {
      this.isFileDownloading = false;
    });
  
    if (partnerFileLink.s3Link) {
      window.location.href = partnerFileLink.s3Link;
      this.isFileDownloading = false;
    }
  }
}
